import { Separator } from '@chakra-ui/react';
import React from 'react';

const CardBodyDivider = () => {
  return <Separator orientation="horizontal" marginY="12px" />;
};

export default CardBodyDivider;
